export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            $(window).scroll(function () {
                var top = $(document).scrollTop();
                if (top == 0 && $('header').hasClass('bg-white')) {
                    $('header').removeClass('bg-white');
                } else {
                    if (!$('header').hasClass('bg-white')) {
                        $('header').addClass('bg-white');
                    }
                }
            });

            var searchButton = $('.header .search__toggle');
            var searchWrap = $('.header .search__wrapper');

            if (searchButton.length > 0) {
                searchButton.on('click', function () {
                    if (searchWrap.hasClass('active')) {
                        searchWrap.removeClass('active').slideUp(500);
                    } else {
                        searchWrap.addClass('active').slideDown(500);
                    }
                })
            }

            $("body").on('click', function (e) {
                if (!$(e.target).closest('.search__wrapper').length && (e.target.className !== "search__toggle")) {
                    if (searchWrap.hasClass('active')) {
                        searchWrap.removeClass('active').slideUp(500)
                    }
                }

            });

            //------------Mobile Menu ------------

            var popupMenu = $('.header__navigation');
            var sandwich = $('.menu__toggle');
            var menu = popupMenu.find('.menu.menu--navigation');

            sandwich.on('click', function () {
                if (popupMenu.hasClass('header__navigation--opened')) {
                    sandwich.removeClass('menu__toggle--clicked');
                    popupMenu.slideUp(500).removeClass('header__navigation--opened');
                    menu.removeClass('menu--mobile');
                } else {
                    sandwich.addClass('menu__toggle--clicked');
                    popupMenu.addClass('header__navigation--opened').slideDown(500);
                    menu.addClass('menu--mobile');
                }
            });

        });
    };

    return _instance;

})(jQuery)